import { G } from '@mobily/ts-belt';
import { FC } from 'react';
import { ResourceContextProvider, useTranslate } from 'react-admin';

import { B2bCompanyDashboard, ShowWithNavigation } from '@sh4res/bo-common/components';
import { shouldMockDashboardData } from '@sh4res/bo-common/utils/should_mock_dashboard_data';

import { useCompanyDetails } from '@Hooks/useCompanyDetails';
import { useCompanyId } from '@Hooks/useCompanyId';

export const CompanyDashboard: FC = () => {
  const translate = useTranslate();
  const companyId = useCompanyId();
  const company = useCompanyDetails();

  if (companyId === null || G.isNullable(company)) {
    return null;
  }

  return (
    <ResourceContextProvider value="dashboard">
      <ShowWithNavigation
        id={companyId}
        queryOptions={{ enabled: false, initialData: company }}
        actions={false}
        avatar={{ name_source: 'name', image_source: 'logo_url' }}
        title={<>{company.name}</>}
        pageTitle={translate('menu.dashboard')}
        sx={{ height: '100%' }}
        data-tour-id="company-show-view">
        <B2bCompanyDashboard resource="companies" useMock={shouldMockDashboardData(companyId)} />
      </ShowWithNavigation>
    </ResourceContextProvider>
  );
};
